import { ImageName } from "@mcleod/images";
import { Image, Label, Layout, LayoutProps } from "@mcleod/components";
import { AuthType, HorizontalAlignment, RegisteredRoutes, VerticalAlignment } from "@mcleod/core";

/**
 * This layout is shown when the user tries to access an authenticated page but they are not signed in.
 */
export class SignInNeeded extends Layout {
    constructor(props: Partial<LayoutProps>) {
        super({
            auth: AuthType.UNAUTH,
            title: "Sign In Needed",
            align: HorizontalAlignment.CENTER,
            fillRow: true,
            verticalAlign: VerticalAlignment.CENTER,
            ...props
        });
        this["tempAllowedUsesOverride"] = [];
        this.add(new Image({ name: ImageName.x, height: 140, width: 388, color: "primary", rowBreak: true, marginTop: 64, marginBottom: 48 }));
        this.add(new Label({ text: "You need to sign in to continue.", color: "primary", fontSize: "xxlarge" }));
        this.add(new Label({ text: "Sign in", link: RegisteredRoutes.loginRoute, linkHardRefresh: true, fontSize: "large" }));
    }
}
